export enum adminCompanyRegionsTypes {
  FETCH_ADMIN_COMPANY_REGIONS_REQUEST = "FETCH_ADMIN_COMPANY_REGIONS_REQUEST",
  FETCH_ADMIN_COMPANY_REGIONS_SUCCESS = "FETCH_ADMIN_COMPANY_REGIONS_SUCCESS",
  FETCH_ADMIN_COMPANY_REGIONS_FAILURE = "FETCH_ADMIN_COMPANY_REGIONS_FAILURE",
}